import { defineComponent as B, computed as m, openBlock as s, createElementBlock as u, normalizeClass as d, Fragment as E, renderList as L, renderSlot as r, createTextVNode as N, toDisplayString as M, ref as w, watch as p, resolveComponent as c, createElementVNode as S, createBlock as V, createCommentVNode as n, createVNode as $, normalizeProps as O, guardReactiveProps as b, mergeProps as z, withCtx as P } from "vue";
import { O as D } from "./OrIconButton-BlHCLpeW.mjs";
import { O as T } from "./OrLoader-2SaTMxmZ.mjs";
import { O as j } from "./OrSearch-YPg77z38.mjs";
import { O as G } from "./OrSorting-DCAarSF1.mjs";
import { _ as A } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
var k = /* @__PURE__ */ ((e) => (e.Grid = "grid", e.List = "list", e))(k || {});
const I = {
  view: "grid",
  icon: "grid_view"
}, R = {
  view: "list",
  icon: "view_agenda"
}, q = [I, R], F = [
  // Layout
  "layout-column",
  // Box
  "h-full",
  // Spacing
  "gap-md"
], U = [
  // Layout
  "layout-row justify-between",
  // Typography
  "typography-body-2-regular",
  // Theme
  "theme-foreground-default",
  "dark:theme-foreground-default-dark"
], H = [
  // Layout
  "layout-inline-row",
  // Spacing
  "gap-lg+"
], J = [
  // Layout
  "grid",
  // Overflow
  "overflow-auto",
  // Spacing
  "px-[5px]",
  // shadow width
  "py-[5px]"
], K = {
  [k.Grid]: [
    // Layout
    "grid-cols-1 md:grid-cols-5",
    // Spacing
    "gap-sm md:gap-md"
  ],
  [k.List]: [
    // Layout
    "grid-cols-1",
    // Spacing
    "gap-sm"
  ]
}, Q = [
  // Layout
  "layout-column items-center justify-center h-full"
], W = B({
  name: "OrCardCollectionView",
  props: {
    items: {
      type: Array,
      default: () => []
    },
    mode: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    return {
      rootStyles: m(() => [
        ...J,
        ...K[e.mode]
      ])
    };
  }
});
function X(e, l, y, h, g, C) {
  return s(), u("div", {
    class: d(e.rootStyles)
  }, [
    (s(!0), u(E, null, L(e.items, (a, t) => r(e.$slots, "item", {
      key: a.key || t,
      index: t,
      item: a,
      mode: e.mode
    }, () => [
      N(M(a.key), 1)
    ])), 128)),
    r(e.$slots, "viewEnd")
  ], 2);
}
const Y = /* @__PURE__ */ A(W, [["render", X]]), Z = B({
  name: "OrCardCollection",
  components: {
    OrCardCollectionView: Y,
    OrIconButton: D,
    OrSorting: G,
    OrSearch: j,
    OrLoader: T
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    view: {
      type: String,
      default: () => I.view
    },
    viewModes: {
      type: Array,
      default: () => q
    },
    sort: {
      type: String,
      default: void 0
    },
    sortOptions: {
      type: Array,
      default: () => []
    },
    search: {
      type: String,
      default: ""
    },
    searchPlaceholder: {
      type: String,
      default: void 0
    },
    searchDebounce: {
      type: Number,
      default: void 0
    },
    loading: {
      type: Boolean,
      default: !1
    },
    enableSearch: {
      type: Boolean,
      default: !0
    }
  },
  emits: [
    "viewChange",
    "sortChange",
    "searchChange"
  ],
  expose: [
    "root"
  ],
  setup(e, l) {
    const y = w(), h = m(() => [
      "or-card-collection-v3",
      ...F
    ]), g = m(() => [
      ...U
    ]), C = m(() => [
      ...H
    ]), a = m(() => [
      ...Q
    ]), t = w(e.view), i = w(e.search);
    function f(o) {
      t.value = o;
    }
    function v(o) {
      i.value = o || "";
    }
    return p(() => e.view, (o) => {
      t.value = o;
    }), p(t, (o) => {
      l.emit("viewChange", o);
    }), p(() => e.search, (o) => {
      i.value = o;
    }), p(i, (o) => {
      l.emit("searchChange", o);
    }), {
      root: y,
      rootStyles: h,
      toolbarStyles: g,
      toolbarPanelStyles: C,
      emptyContainerStyles: a,
      proxyView: t,
      proxySearch: i,
      switchView: f,
      handleSearch: v
    };
  }
}), _ = {
  key: 1,
  class: "layout-row gap-sm"
};
function x(e, l, y, h, g, C) {
  const a = c("OrSorting"), t = c("OrSearch"), i = c("OrIconButton"), f = c("OrCardCollectionView"), v = c("OrLoader");
  return s(), u("div", {
    ref: "root",
    class: d(e.rootStyles)
  }, [
    S("div", {
      class: d(e.toolbarStyles)
    }, [
      S("div", {
        class: d(e.toolbarPanelStyles)
      }, [
        e.sortOptions.length ? (s(), V(a, {
          key: 0,
          "model-value": e.sort,
          options: e.sortOptions,
          "onUpdate:modelValue": l[0] || (l[0] = (o) => e.$emit("sortChange", o))
        }, null, 8, ["model-value", "options"])) : n("", !0),
        r(e.$slots, "toolbar")
      ], 2),
      S("div", {
        class: d(e.toolbarPanelStyles)
      }, [
        e.enableSearch ? r(e.$slots, "search", { key: 0 }, () => [
          $(t, {
            "model-value": e.proxySearch,
            class: "md:w-[350px]",
            placeholder: e.searchPlaceholder,
            debounce: e.searchDebounce,
            onSearch: e.handleSearch
          }, null, 8, ["model-value", "placeholder", "debounce", "onSearch"])
        ]) : n("", !0),
        e.viewModes.length > 1 ? (s(), u("div", _, [
          (s(!0), u(E, null, L(e.viewModes, (o) => (s(), V(i, {
            key: o.view,
            icon: o.icon,
            size: "l",
            selected: o.view === e.proxyView,
            onClick: (ee) => e.switchView(o.view)
          }, null, 8, ["icon", "selected", "onClick"]))), 128))
        ])) : n("", !0),
        r(e.$slots, "addon")
      ], 2)
    ], 2),
    r(e.$slots, "header", O(b({
      items: e.items,
      mode: e.proxyView
    }))),
    e.items.length && !e.loading ? r(e.$slots, e.proxyView, O(z({ key: 0 }, { items: e.items })), () => [
      $(f, {
        items: e.items,
        mode: e.proxyView
      }, {
        item: P((o) => [
          r(e.$slots, "item", O(b(o)))
        ]),
        viewEnd: P(() => [
          r(e.$slots, "viewEnd")
        ]),
        _: 3
      }, 8, ["items", "mode"])
    ]) : n("", !0),
    e.items.length === 0 || e.loading ? (s(), u("div", {
      key: 1,
      class: d(e.emptyContainerStyles)
    }, [
      e.proxySearch.length > 0 && !e.loading ? r(e.$slots, "noSearchResults", {
        key: 0,
        search: e.proxySearch
      }, () => [
        N(" No results ")
      ]) : n("", !0),
      e.loading ? r(e.$slots, "loading", { key: 1 }, () => [
        $(v)
      ]) : n("", !0),
      e.items.length === 0 && e.proxySearch.length === 0 && !e.loading ? r(e.$slots, "empty", { key: 2 }) : n("", !0)
    ], 2)) : n("", !0)
  ], 2);
}
const ae = /* @__PURE__ */ A(Z, [["render", x]]);
export {
  k as C,
  ae as O,
  q as d,
  I as g,
  R as l
};
//# sourceMappingURL=OrCardCollection-B1zsC0GR.mjs.map
